import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  ModalController,
} from '@ionic/angular/standalone';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import { TranslatePipe } from '@ngx-translate/core';

export type ChoiceProps = {
  title?: string;
  image?: any;
  value?: number;
};

@Component({
  selector: 'app-two-choices-modal',
  templateUrl: './two-choices-modal.component.html',
  styleUrls: ['./two-choices-modal.component.scss'],
  standalone: true,
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonFooter,
    TranslatePipe,
  ],
})
export class TwoChoicesModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() firstChoice: ChoiceProps | null = null;
  @Input() secondChoice: ChoiceProps | null = null;
  @Input() value: number = 0;

  private modalController = inject(ModalController);

  public currentValue = 0;

  constructor() {}

  ngOnInit() {
    this.currentValue = this.value;
  }

  public async dismissModal() {
    await this.modalController.dismiss();
  }

  public async continueModal() {
    await this.modalController.dismiss({
      value: this.currentValue,
    });
  }

  public async choiceValue(value: number) {
    this.currentValue = value;
  }
}
